var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "nav-drawer",
      class: { hidden: !_vm.authenticated },
      attrs: { absolute: "", dense: "", width: "250" },
      model: {
        value: _vm.drawer,
        callback: function ($$v) {
          _vm.drawer = $$v
        },
        expression: "drawer",
      },
    },
    [
      _vm.authenticated
        ? _c(
            "v-list",
            { staticClass: "pb-0", attrs: { dense: "" } },
            [
              _c(
                "v-list-item-group",
                { attrs: { color: "blue" } },
                _vm._l(
                  _vm.menu.items.filter((item) => item.isVisible),
                  function (item) {
                    return _c(
                      "v-list-item",
                      {
                        key: item.title,
                        staticClass: "drawer--link",
                        attrs: { link: "", to: item.route },
                      },
                      [
                        _c(
                          "v-list-item-icon",
                          [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-item-content",
                          [
                            _c("v-list-item-title", [
                              _vm._v(_vm._s(item.title)),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }
                ),
                1
              ),
              _vm._v(" "),
              _vm._l(
                _vm.menu.settings.filter((item) => item.isVisible),
                function (item) {
                  return _c(
                    "v-list-group",
                    {
                      key: item.title,
                      attrs: {
                        value: item.active,
                        "prepend-icon": item.action,
                        "active-class": "grey--text text--darken-3",
                        "no-action": "",
                        color: "blue",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function () {
                              return [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", {
                                      domProps: {
                                        textContent: _vm._s(item.title),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _vm._v(" "),
                      _vm._l(item.items, function (child) {
                        return [
                          child.isVisible
                            ? _c(
                                "v-list-item",
                                {
                                  key: child.title,
                                  staticClass: "drawer-item drawer--link",
                                  attrs: { link: "", to: child.route },
                                },
                                [
                                  _c("v-list-item-title", {
                                    staticClass: "pl-6",
                                    domProps: {
                                      textContent: _vm._s(child.title),
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  )
                }
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_ADMIN") && _vm.authenticated
        ? _c(
            "v-list",
            { staticClass: "pt-0", attrs: { dense: "" } },
            _vm._l(_vm.menu.adminSettings, function (item) {
              return _c(
                "v-list-group",
                {
                  key: item.title,
                  attrs: {
                    value: item.active,
                    "prepend-icon": item.action,
                    "active-class": "grey--text text--darken-3",
                    "no-action": "",
                    color: "blue",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function () {
                          return [
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", {
                                  domProps: { textContent: _vm._s(item.title) },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _vm._v(" "),
                  _vm._l(item.items, function (child) {
                    return _c(
                      "v-list-item",
                      {
                        key: child.title,
                        staticClass: "drawer-item drawer--link",
                        attrs: {
                          target: child.target ? child.target : "self",
                          to: child.route,
                          link: "",
                        },
                      },
                      [
                        _c(
                          "v-list-item-content",
                          [
                            _c("v-list-item-title", {
                              staticClass: "pl-6",
                              domProps: { textContent: _vm._s(child.title) },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }